import { Flex, Image, Text } from '@chakra-ui/react';
import { Trans } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import CanopyButton from '../../canopy-ui-components/components/CanopyButton/CanopyButton';
function FourZeroFour(props: any) {
    const location = useLocation();
    const Canopy404 = '/images/canopy-404.svg';
    const { t } = props;
    return (
        <>
            {location?.pathname !== '/' ? (
                <Flex
                    width="100%"
                    align="center"
                    justify="center">
                    <Flex
                        lineHeight="1.75"
                        flexDirection="column"
                        align="center">
                        <Image
                            width="200px"
                            height="150px"
                            m="0 auto"
                            src={Canopy404}
                        />
                        <Text
                            fontSize="5xl"
                            fontWeight="bolder">
                            {t('errors.e-404.title')}
                        </Text>

                        <Text
                            display="inline-block"
                            pl="2rem"
                            pr="2rem"
                            background="#EEEEEE">
                            {t('errors.e-404.error-404')}{' '}
                            <Text as="i">{window.location.href}</Text>
                        </Text>
                        <Text
                            fontSize="16px"
                            mt="20px">
                            <Trans i18nKey="errors.e-404.message">
                                <b
                                    style={{
                                        fontWeight: 900,
                                        fontSize: '16px',
                                        textShadow: '0.5px 0 #888888',
                                    }}>
                                    An error has occurred
                                </b>
                                or the page
                                <b
                                    style={{
                                        fontWeight: 900,
                                        fontSize: '16px',
                                        textShadow: '0.5px 0 #888888',
                                    }}>
                                    &nbsp; does not exist
                                </b>
                                .
                            </Trans>
                        </Text>
                        <Text fontSize="16px">
                            {t('errors.e-404.we-are-working')}
                        </Text>
                        <Flex
                            display="inline-block"
                            justifyContent="center"
                            m="15px">
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href="https://mesitis.atlassian.net/wiki/spaces/HOW/overview">
                                <CanopyButton
                                    fontSize="sm"
                                    boxShadow="2px 2px #EEEEEE"
                                    mr="10px"
                                    variant="outline">
                                    {t('errors.e-404.get-support')}
                                </CanopyButton>
                            </a>
                            <Link to={'/'}>
                                <CanopyButton
                                    fontSize="sm"
                                    boxShadow="2px 2px #EEEEEE"
                                    variant="outline">
                                    {t('errors.e-404.return-to-page')}
                                </CanopyButton>
                            </Link>
                        </Flex>
                    </Flex>
                </Flex>
            ) : null}
        </>
    );
}

export default FourZeroFour;
